import React from 'react'
import { useDrag } from 'react-dnd'
import { Resizable, ResizableBox } from 'react-resizable';

function Element({ id, url }) {
     const [{ isDragging }, drag] = useDrag(() => ({
        type: "element",
         item: { id: id },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));
    return (
        <ResizableBox width={150} height={150}>
        <img
            ref= {drag}
            src={url}
            width="100%"
            height="100%"
            style={{border: isDragging ? "5px solid pink" : "0px"}}
        />
        </ResizableBox>
    );
}

export default Element;
